import { Tag, Tooltip } from 'antd';
import React from 'react';
import {
  INVENTORY_UNIT_LOG_RESULT,
  INVENTORY_UNIT_QR_IMAGE_STATUS,
  INVENTORY_UNIT_STATUS,
  TOOLTIP_Z_INDEX,
  getEnumConfig,
} from './constants';

export const UnitStatusTag = ({ status }) => {
  if (!status) return '-';
  const config = getEnumConfig(INVENTORY_UNIT_STATUS, status);
  return <Tag color={config?.color}>{config?.label}</Tag>;
};

export const QrImageStatusTag = ({ status, error }) => {
  if (!status) return '-';
  const config = getEnumConfig(INVENTORY_UNIT_QR_IMAGE_STATUS, status);
  const tag = <Tag color={config?.color}>{config?.label}</Tag>;
  return error ? (
    <Tooltip title={error} placement="top">
      {tag}
    </Tooltip>
  ) : (
    tag
  );
};

export const QrActiveTag = ({ isActive }) => (
  <Tag color={isActive ? 'success' : 'default'}>
    {isActive ? 'Active' : 'Inactive'}
  </Tag>
);

export const LogResultTag = ({ result }) => {
  if (!result) return '-';
  const config = getEnumConfig(INVENTORY_UNIT_LOG_RESULT, result);
  return <Tag color={config?.color}>{config?.label}</Tag>;
};

export const EllipsisText = ({ value, className = '' }) =>
  value ? (
    <Tooltip title={value} placement="top" zIndex={TOOLTIP_Z_INDEX}>
      <span className={`inventory-units-ellipsis ${className}`}>{value}</span>
    </Tooltip>
  ) : (
    '-'
  );
